module.exports = __webpack_public_path__ + "static/media/ginarogershistoricalmovement.9d1199b0.PNG";